export const disbursementsEn = {
  // Header
  'header.language': 'Language:',

  // Refund Page
  'refund.step': 'Step 1 of 3',
  'refund.title': 'Your refund is ready!',
  'refund.step1.title': 'Let’s make sure it’s you',
  'refund.step1.description':
    'For security, we’ll ask you some verification questions',
  'refund.step2.title': 'Select where to send your money',
  'refund.step2.description':
    'Your bank account or new H&R Block Advantage Prepaid Mastercard ®',
  'refund.protip.title': '💡 Pro Tip',
  'refund.protip.subtitle': 'Make Your H&R Block Card Even Smarter',
  'refund.protip.description':
    'Add your card to your digital wallet and enjoy fast, secure payments wherever you go.',
  'refund.protip.apple': 'Apple Pay',
  'refund.protip.apple.desc': 'iPhone & Apple Watch',
  'refund.protip.google': 'Google Pay',
  'refund.protip.google.desc': 'Android devices',
  'refund.protip.samsung': 'Samsung Pay',
  'refund.protip.samsung.desc': 'Galaxy devices',
  'refund.protip.benefits.title': 'Quick & Secure Payments',
  'refund.protip.benefits.desc':
    'Tap to pay at millions of locations around the world with built-in security and effortless convenience.',
  'refund.button': 'Get Started',

  // Verification Page
  'verification.step': 'Step 2 of 3',
  'verification.back': 'Back to Refund Overview',
  'verification.title': 'Verify your identity.',
  'verification.subtitle': 'Please verify to access your refund',
  'verification.subtitle.desc':
    'To access your refund, please confirm your identity',
  'verification.personal.title': 'Personal information',
  'verification.firstName': 'First Name *',
  'verification.firstName.placeholder': 'Enter your first name',
  'verification.lastName': 'Last Name *',
  'verification.lastName.placeholder': 'Enter your last name',
  'verification.dob': 'Date of birth *',
  'verification.dob.placeholder.date': 'DD',
  'verification.dob.placeholder.month': 'MM',
  'verification.dob.placeholder.year': 'YYYY',
  'verification.sin': 'Last 4 digits of Social Insurance Number *',
  'verification.sin.placeholder': '1234',
  'verification.sin.help': 'Enter the last 4 digits of your SIN',
  'verification.captcha': 'Security Verification (reCAPTCHA) *',
  'verification.captcha.text': 'I’m not a robot',
  'verification.captcha.help': 'Please complete the reCAPTCHA verification',
  'verification.agreements.title': 'Review and accept',
  'verification.agreement1':
    'I agree to the Cardholder Agreement and understand the terms and conditions of my H&R Block card.',
  'verification.agreement2':
    'I authorize H&R Block to activate my card and initiate the fund transfer to my selected account.',
  'verification.agreement3':
    'I agree to the Privacy Policy and consent to the collection and use of my personal information as described.',
  'verification.security.title': 'Your Privacy & Security',
  'verification.security.desc':
    'Your personal information is encrypted and securely transmitted. H&R Block uses industry-standard security measures to protect your data and will never share your information without your consent.',
  'verification.security.detailed':
    'Your information is protected with bank-grade encryption and secure transmission. H&R Block follows industry-leading standards to safeguard your data and will never share your personal details without your permission.',
  'verification.button': 'Continue',
  'verification.button.help.agreements':
    'Please complete all required fields and agreements to continue',
  'verification.button.help': 'Please complete all required fields to continue',
  'verification.error.failed': 'We couldn’t verify your details',
  'verification.error.retry1':
    'What you entered doesn’t match our records. Please review your information and try again. You have <b>1 more try</b> before this link expires.',
  'verification.error.retry2':
    'What you entered doesn’t match our records. <br> Please review your information and try again. You have <b>2 more tries</b> before this link expires.',
  'verification.error.sin.invalid': 'Enter the last 4 digits of your SIN.',
  'verification.error.dob.invalid':
    'Enter a date of birth in a valid format.',
  // Transfer Options Page
  'transfer.step': 'Step 3 of 3',
  'transfer.back': 'Back to Verification',
  'transfer.title': 'Choose Your Transfer Method',
  'transfer.subtitle': 'Select how you’d like to receive your refund',
  'transfer.balance.title': 'Your Tax Refund',
  'transfer.balance.available': 'Available balance',
  'transfer.section.title': 'Transfer your refund.',
  'transfer.section.subtitle': 'Select one of the following options',
  'transfer.keep.title': 'H&R Block Advantage Prepaid Mastercard ®',
  'transfer.keep.desc':
    'Activate and use your virtual Mastercard®.\nInstant access to your money.\n<a href="https://www.hrblock.ca/advantagecard">Learn more</a>',
  'transfer.keep.cardholder.link':
    '<a href="/cardholder-agreement.pdf">Cardholder fees</a>',
  'transfer.keep.cardholder': 'apply.',
  'transfer.keep.fee':
    '<a href="https://hrblockadvantagecard.payaccount.io/cardholder-agreement">Cardholder fees</a> apply',
  'transfer.visa.title': 'Visa* Direct',
  'transfer.visa.desc':
    'Send the refund to your <b>Visa debit card</b>.\nTransfer to your card in minutes.\n<a href="https://hrblockadvantagecard.mycardholdersupport.com/portal/en/kb/articles/visa-direct-request-and-send#Step_By_Step__Without_Screenshots">Learn more</a>',
  'transfer.interac.title': 'Interac e-Transfer ®',
  'transfer.interac.desc':
    'Send the refund to your bank.\n Allow up to 1 hour for the funds to arrive.\n<a href="https://hrblockadvantagecard.mycardholdersupport.com/portal/en/kb/articles/interac-request-and-send">Learn more</a>',
  'transfer.fee': 'Transfer fee:',
  'transfer.nofee': 'No transfer fee',
  'transfer.button': 'Continue with',
  'transfer.continue': 'Continue',
  'transfer.button.help.keep':
    'Your funds will remain available on your H&R Block card',
  'transfer.button.help.fee': 'fee will be deducted from your balance',
  'transfer.dynamic.keep':
    'Your funds will remain available on your H&R Block card',
  'transfer.dynamic.fee': 'will be deducted from your balance',
  'transfer.select': 'Please select an option to continue',
  // trademarks
  'transfer.trademark.disclaimer.interac':
    '® Registered trademark of Interac Corp. INTERAC and the INTERAC logo are trademarks of Interac Corp. Used under licence.',
  'transfer.trademark.disclaimer.visa':
    '*Trademark of Visa International Service Association and used under licence by Peoples Trust Company.',
  'transfer.trademark.disclaimer.mastercard':
    'The H&R Block Advantage Prepaid Mastercard® is issued by Peoples Trust Company under licence from Mastercard International.',

  // Create Account Page
  'account.step': 'Final Step',
  'account.back': 'Back to Transfer Options',
  'account.title': 'Create a new account.',
  'account.subtitle': 'Set up your',
  'account.subtitle.bold': 'H&R Block Advantage Prepaid Mastercard ®',
  'account.info.title': 'Account Information',
  'account.username': 'Create a username *',
  'account.username.placeholder':
    'Enter a minimum of 3 alphanumeric characters.',
  'account.username.valid': 'Username is valid',
  'account.username.invalid': 'Enter a minimum of 3 alphanumeric characters',
  'account.password': 'Create a password *',
  'account.password.placeholder': 'Choose password',
  'account.password.requirements': 'Password requirements:',
  'account.password.req1': '12 or more characters',
  'account.password.req2': 'Contains uppercase letter',
  'account.password.req3': 'Contains lowercase letter',
  'account.password.req4': 'Has a number',
  'account.password.req5': 'Has a special character',
  'account.confirm': 'Confirm your password *',
  'account.confirm.placeholder': 'Re-enter the password',
  'account.confirm.match': 'Passwords match',
  'account.confirm.nomatch': 'Passwords do not match',
  'account.security.title': 'Account Security',
  'account.security.desc':
    'Your account credentials are encrypted and stored securely. You’ll use these to access your H&R Block card account and manage your funds online.',
  'account.button': 'Create Account',
  'account.button.help': 'Please enter the required information to continue',
  'account.login': 'Account Created!',
  'account.login.message':
    'Your <b>H&R Block Advantage Prepaid Mastercard ®</b> account has been successfully created.',
  'account.username.error.title': 'Username is taken. Choose another',
  'account.username.error.message':
    'This username is already being used. Please create a username with a minimum of 3 characters. You can add letters and numbers to make it unique.',

  // Account Created Page
  'accountCreated.title': 'Account already created.',
  'accountCreated.message':
    'This verification link has already been used to create your',
  'accountCreated.message.bold': 'H&R Block Prepaid Advantage Mastercard ®',
  'accountCreated.message._': 'account.',
  'accountCreated.alreadyProcessed':
    'Your account setup was successfully completed previously.',
  'accountCreated.info.title': 'Account Status',
  'accountCreated.info.point1':
    'Your H&R Block card account has been successfully created and is ready to use.',
  'accountCreated.info.point2':
    'This verification link can only be used once for security purposes.',
  'accountCreated.info.point3':
    'You can now log in to access your account and manage your card.',
  'accountCreated.details.title': 'What You Can Do Now',
  'accountCreated.access.title': 'Access Your Account',
  'accountCreated.access.desc': 'Log in with your username and password',
  'accountCreated.access.note':
    'Use the credentials you created during account setup',
  'accountCreated.management.title': 'Manage Your Card',
  'accountCreated.management.desc':
    'View balance, transactions, and card settings',
  'accountCreated.management.note': 'Full account management available online',
  'accountCreated.nextSteps.title': 'Next Steps',
  'accountCreated.nextSteps.step1.label': 'Log in to your account',
  'accountCreated.nextSteps.step1.desc':
    'Use your username and password to access your dashboard',
  'accountCreated.nextSteps.step2.label': 'Review your card details',
  'accountCreated.nextSteps.step2.desc':
    'Check your balance and recent transactions',
  'accountCreated.nextSteps.step3.label': 'Start using your card',
  'accountCreated.nextSteps.step3.desc':
    'Make purchases or transfer funds as needed',
  'accountCreated.loginButton': 'Go to Log In',
  'accountCreated.startNewDemo': 'Start New Demo',

  // Visa Direct Page
  'visa.step': 'Step 3 of 3',
  'visa.back': 'Back to Transfer Options',
  'visa.title': 'Transfer to a Visa card.',
  'visa.subtitle': 'Enter your',
  'visa.subtitle.visa': 'Visa debit card information',
  'visa.subtitle._': 'to receive your refund',
  'visa.balance.title': 'Your Tax Refund',
  'visa.balance.available': 'Available balance',
  'visa.balance.fee': 'Transfer fee',
  'visa.card.title': 'Recipient’s information',
  'visa.firstName': 'First Name *',
  'visa.middleName': 'Middle Name',
  'visa.lastName': 'Last Name *',
  'visa.fullName': 'Full Name on Card *',
  'visa.cardNumber': 'Card number *',
  'visa.expiryMonth': 'Expiry Month *',
  'visa.expiryYear': 'Expiry Year *',
  'visa.cvv': 'Security Code (CVV - 3 digits)',
  'visa.button': 'Complete Transfer',
  'visa.button.help': 'Please enter the required information to continue',
  'visa.submitTransfer': 'Continue',

  // Transfer Success Page
  'success.title': 'Visa transfer sent.',
  'success.subtitle':
    'You’ve transferred your refund successfully. View the  receipt below for the transfer details.',
  'success.subtitle.completed':
    'It may take a few minutes to receive the funds on your account',
  'success.details.title': 'Transaction details',
  'success.amount': 'Amount transferred',
  'success.fee': 'Transfer fees',
  'success.original': 'Original amount',
  'success.id': 'Transaction ID',
  'success.processor_reference': 'PRN',
  'success.method': 'Transfer method',
  'success.method.interac': 'Interac e-Transfer',
  'success.date': 'Date and time',
  'success.complete.title': 'Transfer Complete',
  'success.complete.desc':
    'Your funds have been successfully transferred to your Visa debit card and should be available now.',
  'success.download': 'Download Receipt',
  'success.share': 'Share Receipt',
  'success.next.title': 'What’s Next?',
  'success.next.step1':
    'Check your bank account or card balance to confirm the transfer',
  'success.next.step2': 'Keep your transaction ID for your records',
  'success.next.step3':
    'Contact support if you have any questions about your transfer',
  'success.back': 'Start New Demo',

  // Account Home Page
  'home.demo.back': '← Back to Start (Demo)',
  'home.welcome': 'Welcome to your Dashboard, Ganesh Swami!',
  'home.cardNumber': 'Card Number XXXX XXXX XXXX 9251',
  'home.suspend': 'Suspend Card',
  'home.nav.dashboard': 'Dashboard',
  'home.nav.transfers': 'Transfers',
  'home.nav.profile': 'My Profile',
  'home.nav.card': 'About My Card',
  'home.balance': 'Balance',
  'home.status': 'Account Status',
  'home.status.active': 'Active',
  'home.expiry': 'Expiry Date',
  'home.transactions': 'Transactions',
  'home.view': 'View',
  'home.export': 'Export to:',
  'home.from': 'From:',
  'home.to': 'To:',
  'home.noTransactions': 'No Transactions have been made on this Account',

  // Login Page
  'login.title': 'Login',
  'login.instruction': 'Please enter your username and password.',
  'login.activate': 'If your card is not activated,',
  'login.activate.link': 'click here to activate it',
  'login.register': 'If your card is activated,',
  'login.register.link': 'click here to register your account',
  'login.agreement': 'To view or download your cardholder agreement,',
  'login.agreement.link': 'click here',
  'login.username': '* Username',
  'login.password': '* Password',
  'login.submit': 'Submit',
  'login.forgot': 'Forgot Password',
  'login.back': '← Back to Start (Demo)',
  'login.footer.mastercard':
    'In Canada, Mastercard prepaid card is issued by Peoples Trust Company under license from Mastercard International Incorporated. Mastercard is a registered trademark, and the circle’s design is a trademark of Mastercard International Incorporated.',
  'login.footer.visa.ca':
    'In Canada, Visa prepaid card issued by Equitable Bank pursuant to a license by Visa Int. *Trademark of Visa Int, used under license by Equitable Bank.',
  'login.footer.visa.us':
    'In the United States, Visa® prepaid card is issued by Sunrise Banks N.A., Member FDIC, pursuant to a license from Visa U.S.A. Inc. The Visa logo is a registered trademark of Visa International.',

  // Link Expired Page
  'expired.title': 'Your link has expired',
  'expired.sorry': 'Your verification link expired due to',
  'expired.sorry.bold': 'inactivity',
  'expired.timeout':
    'Links expire after 48 hours of inactivity for your security.',
  'expired.what.title': 'What happened?',
  'expired.what.point1':
    'Your Direct Send verification link was sent to you, but it has now expired due to 48 hours of inactivity.',
  'expired.what.point2':
    'This security measure protects your personal information and refund details.',
  'expired.what.point3':
    'A new verification link must be generated from the H&R Block office where you filed your taxes.',
  'expired.office.title': 'Visit Your H&R Block Office',
  'expired.office.instruction':
    'Your verification link expired due to inactivity.',
  'expired.office.step1':
    'Visit the same H&R Block office location where you filed your taxes',
  'expired.office.step2':
    'Speak with a tax professional to request a new Direct Send verification link',
  'expired.office.step3':
    'You will receive a fresh link via email or SMS to complete your refund process',
  'expired.bring.title': 'What to do next?',
  'expired.bring.id':
    'Visit the same H&R Block office where you filed your return.',
  'expired.bring.sin': 'Bring a valid government-issued photo ID.',
  'expired.bring.receipt': 'Speak with a Tax Expert to receive a new link.',
  'expired.start_new_demo': 'Start New Demo',
  // session terminated page
  'session.warning.title': 'Warning - Your session will be cancelled',
  'session.warning.instruction.back':
    'If you press the browser back button, your session will be terminated and you won’t be able to continue where you left off. You’ll need to restart from the beginning.',
  'session.warning.instruction.refresh':
    'If you press the browser refresh button, your session will be terminated and you won’t be able to continue where you left off. You’ll need to restart from the beginning.',
  'session.warning.instruction.confirm':
    'IMPORTANT: This action will immediately end your current session and all unsaved progress will be lost. You will need to restart the process from the beginning.',
  'session.terminated.title': 'Session terminated',
  'session.terminated.instruction':
    'Your session has been permanently terminated because the',
  'session.terminated.instruction.reason.back': 'the browser’s back button',
  'session.terminated.instruction.reason.refresh': 'browser\'s refresh button',
  'session.terminated.reason': 'has been used.',
  'session.terminated.nextstep':
    'To restart, access the link sent to you via email and or SMS.',
  'session.expired':
    'Your secure session has expired. Verify your information to continue.',
  // Interac Transfer Page
  'interac.step': 'Step 3 of 3',
  'interac.back': 'Back to Transfer Options',
  'interac.balance.title': 'Your Tax Refund',
  'interac.balance.available': 'Available balance',
  'interac.balance.fee': 'Transfer fee',
  'interac.title': 'Interac e-Transfer.®',
  'interac.subtitle': 'Enter your Interac e-Transfer email to receive funds',
  'interac.contact.title': 'Recipient’s information',
  'interac.name': 'Name *',
  'interac.email': 'Email *',
  'interac.security.question': 'Security question',
  'interac.security.answer': 'Security answer',
  'interac.security.answer.placeholder': 'Enter security answer',
  'interac.checking': 'Checking auto deposit status...',
  'interac.auto.enabled': '✅ Auto Deposit Enabled',
  'interac.auto.enabled.desc':
    'Great! Auto deposit is enabled for this email. No security question required.',
  'interac.auto.checking': '🔍 Checking Auto Deposit Status',
  'interac.auto.checking.desc':
    'Verifying if auto deposit is enabled for this email address...',
  'interac.info.title': '💡 Interac e-Transfer Information',
  'interac.info.time':
    '• Transfer time: Typically completes within minutes to a few hours',
  'interac.info.transferTime': 'Transfer time:',
  'interac.info.transferTimeValue':
    'Typically completes within minutes to a few hours',
  'interac.info.security': 'Security:',
  'interac.info.security.required':
    'Security question required for this transfer',
  'interac.info.security.auto':
    'Auto deposit enabled - no security question needed',
  'interac.info.security.pending':
    'Security requirements will be determined after email verification',
  'interac.info.fee':
    '• Fee: A $3.95 transfer fee will be deducted from your balance',
  'interac.info.feeLabel': 'Fee:',
  'interac.info.feeValue':
    'A $3.95 transfer fee will be deducted from your balance',
  'interac.submit': 'Continue',
  'interac.submit.checking': 'Checking...',
  'interac.submit.help.checking':
    'Please wait while we check auto deposit status',
  'interac.submit.help.demo':
    'Please select an auto deposit option for PTC demo',
  'interac.submit.help.complete':
    'Please complete all required fields to continue',
  'interac.demo.ptc': '🔧 PTC Demo Options',
  'interac.demo.ptc.desc': 'Choose auto deposit status for testing (Demo Only)',
  'interac.demo.enabled': '✅ Auto Deposit Enabled',
  'interac.demo.disabled': '⚠️ Auto Deposit Not Enabled',
  'interac.demo.exceptions': '🧪 Demo Exception Scenarios',
  'interac.demo.exceptions.desc':
    'Test different transfer error scenarios (Demo Only)',
  'interac.demo.escrow': '⏰ Insufficient Escrow Balance Error',
  'interac.demo.network': '📡 E-Transfer Network Error',
  'interac.transfer.failed': 'Transfer failed - Technical issue',
  'interac.transfer.failed.message':
    'Your Interac e-Transfer failed due to a technical error. If the issue persists, please contact the Cardholder support at  1-855-342-6924 or hrblockadvantagecard@mycardholdersupport.com',
  'interac.transfer.unavailable': 'Transfer temporarily unavailable',
  'interac.transfer.unavailable.message':
    'We’re experiencing temporary issues. Please try again in 24 hours.',

  // Shared escrow error messages (used by both Visa and Interac)
  'disbursement.error.insufficient_escrow.title': 'Transfer Temporarily Unavailable',
  'disbursement.error.insufficient_escrow.message':
    'We’re experiencing a temporary issue with our payment processor that’s preventing transfers at this time. Please try your transfer again in 4 hours. We apologize for any inconvenience.',

  // Add these missing keys to the EN translations:
  'interac.stepIndicator': 'Step 3 of 3',
  'interac.backButton': 'Back to Transfer Options',
  'interac.yourHRBlockCard': 'Your H&R Block Card',
  'interac.availableBalance': 'Available balance',
  'interac.transferFee': 'Transfer fee',
  'interac.namePlaceholder': 'Enter recipient’s full name',
  'interac.emailPlaceholder': 'Enter Interac e-Transfer email address',
  'interac.checkingAutoDeposit': 'Checking auto deposit status...',
  'interac.autoDeposit.enabled.title': '✅ Auto Deposit Enabled',
  'interac.autoDeposit.enabled.subtitle':
    'Great! Auto deposit is enabled for this email. No security question required.',
  'interac.autoDeposit.checking.title': '🔍 Checking Auto Deposit Status',
  'interac.autoDeposit.checking.subtitle':
    'Verifying if auto deposit is enabled for this email address...',
  'interac.info.securityRequirements':
    'Security requirements will be determined after email verification',
  'interac.info.securityQuestionRequired':
    'Security question required for this transfer',
  'interac.info.autoDepositEnabled':
    'Auto deposit enabled - no security question needed',
  'interac.submitTransfer': 'Continue',
  'interac.waitAutoDeposit': 'Please wait while we check auto deposit status',
  'interac.selectAutoDepositOption':
    'Please select an auto deposit option for PTC demo',
  'interac.completeRequiredFields':
    'Please complete all required fields to continue',
  'interac.ptcDemoOptions.title': '🔧 PTC Demo Options',
  'interac.ptcDemoOptions.subtitle':
    'Choose auto deposit status for testing (Demo Only)',
  'interac.ptcDemoOptions.enabled': '✅ Auto Deposit Enabled',
  'interac.ptcDemoOptions.disabled': '⚠️ Auto Deposit Not Enabled',
  'interac.demoException.title': '🧪 Demo Exception Scenarios',
  'interac.demoException.subtitle':
    'Test different transfer error scenarios (Demo Only)',
  'interac.demoException.escrow': '⏰ Insufficient Escrow Balance Error',
  'interac.demoException.network': '📡 E-Transfer Network Error',
  'interac.dismiss': 'Dismiss',
  'interac.demoOnly': 'Demo Only',
  'interac.error.name': 'Enter your name to continue',
  'interac.error.name.length': 'Name must be at least 2 characters',
  'interac.error.name.consecutiveSpaces': 'Name cannot contain consecutive spaces',
  'interac.error.email': 'Enter your email to continue',
  'interac.error.email.invalid': 'Enter a valid email address, for example name@example.com.',
  'interac.error.email.rejected':
    'We couldn’t use this email address. Check it for typos and try again.',
  'interac.error.name.characters':
    'Your name can only use letters, numbers, spaces and hyphens, and must be 3 to 80 characters long.',
  'interac.error.name.firstLast':
    'Enter your first and last name only, separated by a single space (for example, Jane Smith).',
  'interac.error.name.rejected':
    'We couldn’t use this name. Check it for typos, enter your first and last name, and try again.',
  'interac.error.details.title': 'Check your name and email',
  'interac.error.details.message':
    'We couldn’t set up the e-Transfer with the name and email address you entered. Check that the name is your first and last name and that the email address is correct, then try again.',
  'interac.emailConfirm': 'Confirm email *',
  'interac.emailConfirm.placeholder': 'Re-enter Interac e-Transfer email',
  'interac.error.emailConfirm': 'Re-enter your email to confirm it.',
  'interac.error.emailConfirm.mismatch':
    'The email addresses don’t match. Check both for typos.',
  'interac.error.securityAnswer': 'Enter a security answer to the question.',
  'interac.error.securityAnswer.minLength':
    'The security answer must be 3-25 characters, using only letters and numbers (no spaces).',
  'interac.error.securityAnswer.maxLength':
    'The security answer must be 3-25 characters, using only letters and numbers (no spaces).',
  'interac.error.securityAnswer.pattern':
    'The security answer must be 3-25 characters, using only letters and numbers (no spaces).',
  // Add these missing placeholder keys for interac transfer page
  'interac.name.placeholder': 'Enter full name',
  'interac.email.placeholder': 'Enter Interac e-Transfer email',
  'interac.autodeposit.enabled':
    'Auto deposit enabled - no security question needed',
  'interac.autodeposit.disabled':
    'Autodeposit not enabled. Enter a security question.',

  // Interac Success Page
  'interac.success.title': 'Interac e-Transfer® sent.',
  'interac.success.subtitle':
    'An email from Interac will be sent within 1 hour. Please <b>follow the instructions to</b> complete the transfer',
  'interac.success.subtitle.autodeposit':
    'Allow up to 1 hour for the funds to arrive',
  'interac.success.details': 'Transaction details',
  'interac.success.amount': 'Amount Transferred',
  'interac.success.fee': 'Transfer Fee',
  'interac.success.original': 'Original Amount',
  'interac.success.recipient.name': 'Recipient Name',
  'interac.success.recipient.email': 'Recipient Email',
  'interac.success.id': 'Transaction ID',
  'interac.success.method': 'Transfer Method',
  'interac.success.method.interac': 'Interac e-Transfer',
  'interac.success.date': 'Date & Time',
  'interac.success.status.title': '✅ Transfer Initiated Successfully',
  'interac.success.status.desc': 'Your Interac e-Transfer has been sent to',
  'interac.success.status.instruction':
    'The recipient will receive an email notification with instructions to deposit the funds.',
  'interac.success.delivery':
    '• Expected delivery: Within minutes to a few hours',
  'interac.success.notification':
    '• Recipient notification: Email sent automatically',
  'interac.success.security.question': 'Security question required for deposit',
  'interac.success.security.auto':
    'Auto deposit enabled - no security question needed',
  'interac.success.next.title': 'What happens next?',
  'interac.success.next.step1':
    '1. Email notification sent: The recipient will receive an email from Interac with deposit instructions',
  'interac.success.next.step2':
    '2. Recipient deposits funds: They’ll follow the link in the email to deposit the money to their bank account',
  'interac.success.next.step3':
    '3. Transfer completes: Once deposited, the transfer is complete and funds are available to the recipient',
  'interac.success.next.step4':
    '4. Keep your transaction ID: Save this for your records in case you need to reference this transfer',
  'interac.success.download': 'Download Receipt',
  'interac.success.share': 'Share Receipt',
  'interac.success.amountTransferred': 'Amount transferred',
  'interac.success.transferFee': 'Transfer fee',
  'interac.success.originalAmount': 'Original amount',
  'interac.success.recipientName': 'Recipient Name',
  'interac.success.recipientEmail': 'Sent to',
  'interac.success.transactionId': 'Transaction ID',
  'interac.success.reference': 'PRN',
  'interac.success.transferMethod': 'Transfer method',
  'interac.success.dateTime': 'Date and time',
  'interac.success.transferInitiated': 'Transfer Initiated Successfully',
  'interac.success.transferSent': 'Your Interac e-Transfer has been sent to',
  'interac.success.recipientNotification':
    'The recipient will receive an email notification with instructions to deposit the funds.',
  'interac.success.expectedDeliveryLabel': 'Expected delivery',
  'interac.success.expectedDelivery': 'Within minutes to a few hours',
  'interac.success.recipientNotificationLabel': 'Recipient notification',
  'interac.success.emailSentAutomatically': 'Email sent automatically',
  'interac.success.securityLabel': 'Security',
  'interac.success.securityQuestionRequired':
    'Security question required for deposit',
  'interac.success.autoDepositEnabled':
    'Auto deposit enabled - no security question needed',
  'interac.success.whatHappensNextTitle': 'What happens next?',
  'interac.success.nextStep1Label': 'Email notification sent',
  'interac.success.nextStep1':
    'The recipient will receive an email from Interac with deposit instructions',
  'interac.success.nextStep2Label': 'Recipient deposits funds',
  'interac.success.nextStep2':
    'They’ll follow the link in the email to deposit the money to their bank account',
  'interac.success.nextStep3Label': 'Transfer completes',
  'interac.success.nextStep3':
    'Once deposited, the transfer is complete and funds are available to the recipient',
  'interac.success.nextStep4Label': 'Keep your transaction ID',
  'interac.success.nextStep4':
    'Save this for your records in case you need to reference this transfer',
  'success.alert.title': 'Refund already sent',
  'success.alert.message':
    'You’ve transferred your refund successfully. View the  receipt below for the transfer details.',
  'success.alert.date': ' the date shown below.',
  'success.status.title': 'Transfer Complete',
  'success.status.message':
    'Your funds have been successfully transferred and should be available now.',
  'interac.success.expectedDeliveryTime':
    'Expected delivery time: Within minutes to a few hours depending on the recipient’s bank',
  'interac.success.auto.title': 'Interac e-Transfer sent.',
  'interac.success.auto.subtitle': 'Allow up to 1 hour for the funds to arrive',
  'interac.success.auto.depositTitle': 'Automatic Deposit Complete',
  'interac.success.auto.depositMessage':
    'Your Interac e-Transfer has been automatically deposited into the recipient’s bank account. No further action is required from the recipient.',
  'interac.success.auto.availabilityMessage':
    'The funds are now available in the recipient’s account and can be used immediately.',

  // Visa Direct Page - Error messages
  'visa.error.verification.title': 'Card verification failed',
  'visa.error.verification.message':
    'Your card could not be verified. Please review your <b>card information</b> and try again.',
  'visa.error.fraud.title': 'Card not eligible for transaction',
  'visa.error.fraud.message':
    'This card is not eligible for Visa Direct transfer. Please try again with a different Visa debit card.',
  'visa.error.escrow.title': 'Transfer Temporarily Unavailable',
  'visa.error.escrow.message':
    'We’re experiencing a temporary issue with our payment processor that’s preventing transfers at this time. Please try your transfer again tomorrow or after 24 hours. We apologize for any inconvenience.',
  'visa.demo.title': '🧪 Demo Exception Scenarios',
  'visa.demo.subtitle': 'Test different transfer error scenarios (Demo Only)',
  'visa.demo.verification': '⚠️ Card verification failed',
  'visa.demo.fraud': '🛡️ Suspected Fraud',
  'visa.demo.escrow': '⏰ Insufficient Escrow Balance Error',
  'visa.error.dismiss': 'Dismiss',
  // visa.errors.* keys (used in errorMap)
  'visa.errors.verification.title': 'Card verification failed',
  'visa.errors.verification.message':
    'Your card could not be verified. Please review your <b>card information</b> and try again.',
  'visa.errors.fraud.title': 'Card not eligible for transaction',
  'visa.errors.fraud.message':
    'This card is not eligible for Visa Direct transfer. Please try again with a different Visa debit card.',
  'visa.errors.escrow.title': 'Transfer Temporarily Unavailable',
  'visa.errors.escrow.message':
    'We\'re experiencing a temporary issue with our payment processor that\'s preventing transfers at this time. Please try your transfer again tomorrow or after 24 hours. We apologize for any inconvenience.',
  'visa.errors.dismiss': 'Dismiss',

  // Transfer Success Page - Additional
  'success.status.complete': '✅ Transfer Complete',
  'success.status.desc':
    'Your funds were successfully transferred to your Visa debit card and should be available now.',
  'success.completed.title': 'Transfer Already Completed',
  'success.completed.desc':
    'This verification link has already been used. Your transfer was successfully processed on the date shown below.',

  // Demo sections (common across pages)
  'demo.title': '🧪 Demo Exception Scenarios',
  'demo.desc': 'Test different exception handling scenarios (Demo Only)',
  'demo.verification.scenarios': '🧪 Demo Verification Failure Scenarios',
  'demo.verification.desc':
    'Test progressive verification failure scenarios (Demo Only)',
  'demo.fail1': '⚠️ 1st Verification Fail',
  'demo.fail2': '🚨 2nd Verification Fail',
  'demo.fail3': '🔒 3rd Verification Fail',
  'demo.money.complete': '💰 Money Transfer Complete',
  'demo.account.created': '✅ Account Created',
  'demo.link.expired': '⚠️ Link Expired',

  // Common form elements
  'form.required': '*',
  'form.dismiss': 'Dismiss',
  'form.back': 'Back',
  'form.continue': 'Continue',
  'form.submit': 'Submit',
  'form.complete': 'Complete',
  'form.checking': 'Checking...',
  'form.processing': 'Processing...',

  // Common
  'common.cardholder': 'Cardholder Agreement',
  'common.privacy': 'Privacy Policy',
  'common.goBack': 'Back to options',
  'common.goBackVerify': 'Go Back',
  'common.dismiss': 'Dismiss',
  'verification.dob.placeholder': 'MM/DD/YYYY',
  'transfer.interac.setup': 'Requires email and security question setup.',
  'transfer.interac.learnmore': 'Learn more',
  'account.username.help':
    'Your username will be used to log into your account',
  'account.username.description':
    'Your username will be used to log into your account',
  'visa.nameOnCard': 'Name on card *',
  'visa.nameOnCard.placeholder': 'Enter the name on the Visa debit card',
  'visa.nameOnCard.help': 'Enter the name on the Visa debit card',
  'visa.expiry': 'Expiry date',
  'visa.noCvvNeeded': 'No CVV needed.',
  'visa.address1': 'Address line 1 *',
  'visa.address1.help': 'Enter the address associated with the Visa debit card',
  'visa.address2': 'Address line 2',
  'visa.city': 'City *',
  'visa.provinceState': 'Province *',
  'visa.provinceState.placeholder': 'Select Province',
  'visa.postalCode': 'Postal code *',
  'visa.country': 'Country',
  'visa.continue': 'Continue',
  'success.prn': 'PRN',
  'interac.auto.disabled':
    'Auto deposit not enabled - security question required',
  'interac.success.prn': 'PRN',
  'validation.name.required': 'Name is required',
  'validation.name.minLength': 'Name must be at least 2 characters',
  'validation.email.required': 'Email is required',
  'validation.email.invalid': 'Please enter a valid email address',
  'validation.securityQuestion.required': 'Security question is required',
  'validation.securityAnswer.required': 'Security answer is required',
  'validation.securityAnswer.minLength':
    'Security answer must be at least 2 characters',
  'visa.errors.fullNameOnCard.required':
    'Name on card is required. Enter the exact name on your Visa card.',
  'visa.errors.fullNameOnCard.minLength': 'Name must be at least 2 characters',
  'visa.errors.cardNumber.required': 'Card number is required.',
  'visa.errors.cardNumber.exactLength': 'Card number must be exactly 16 digits',
  'visa.errors.cardNumber.onlyDigits': 'Card number must contain only digits',
  'visa.errors.cardNumber.invalid': 'Please enter a valid card number',
  'visa.errors.cvv.required': 'The CVV is required. Enter the 3-digit code.',
  'visa.errors.cvv.exactLength': 'Security code must be exactly 3 digits',
  'visa.errors.expiryMonth.required': 'The expiry month is required.',
  'visa.errors.expiryMonth.invalid': 'Please select a valid month',
  'visa.errors.expiryYear.required': 'Expiry year is required',
  'visa.errors.expiryYear.expired': 'Card has expired',
  'visa.errors.expiryYear.invalid': 'Please select a valid year',
  'visa.errors.address1.required': 'The address line 1 is required.',
  'visa.errors.address1.minLength': 'Address must be at least 5 characters',
  'visa.errors.city.required': 'The city is required.',
  'visa.errors.city.minLength': 'City must be at least 2 characters',
  'visa.errors.provinceState.required': 'The province is required.',
  'visa.errors.postalCode.required': 'The postal code is required.',
  'visa.errors.postalCode.invalidFormat':
    'Enter a valid postal code (A1A 1A1).',
  'visa.errors.country.required': 'Country is required',
  'visa.errors.country.onlyCanada': 'Only Canadian addresses are supported',
  'valid_etransfer_name': 'Enter the recipient\'s first and last name',
  // verification failed
  'verificationFailed.title': 'Failed verification',
  'verificationFailed.terminated': 'This link has expired due to ',
  'verificationFailed.terminated.bold':
    'multiple failed verification attempts.',
  'verificationFailed.nextSteps.title': 'What to do next?',
  'verificationFailed.nextSteps.step1': 'Visit the',
  'verificationFailed.nextSteps.step1.1': 'same H&R Block office',
  'verificationFailed.nextSteps.step1.2': 'where you filed your return.',
  'verificationFailed.nextSteps.step2':
    'Bring a valid government-issued photo ID.',
  'verificationFailed.nextSteps.step3':
    'Speak with a Tax Expert to receive a new link.',
  'verificationFailed.nextSteps.step4':
    'Request a new verification link to access your refund',

  // Navigation guard modal
  'nav.back.title': 'Navigation Violation Detected',
  'nav.back.lead':
    'Unauthorized browser navigation detected. Session terminated.',
  'nav.back.desc':
    'You attempted to use the browser’s back button during a secure financial transaction. This action violates our security protocols and your session has been permanently terminated to protect your information.',
  'nav.back.detail1': 'Browser back button usage detected',
  'nav.back.detail2': 'Secure session has been invalidated permanently',
  'nav.back.detail3': 'All transaction data has been purged',
  'nav.back.detail4': 'Session cannot be restored for security reasons',
  'nav.back.notice':
    'This security measure protects your financial information from unauthorized access. Browser navigation is strictly prohibited during secure transactions. This session is now permanently closed.',

  'nav.refresh.title': 'Session terminated',
  'nav.refresh.lead':
    'Your session has been permanently terminated because the',
  'nav.refresh.lead.bold': 'browser’s refresh button',
  'nav.refresh.lead._': 'has been used.',
  'nav.refresh.restart':
    'To restart, access the link sent to you via email and or SMS.',
  'nav.refresh.desc':
    'We detected that you attempted to refresh or close the browser during the transfer process. For your security, this action is not permitted and your session has been terminated.',
  'nav.refresh.detail1': 'Browser refresh/close attempt detected',
  'nav.refresh.detail2': 'Secure session has been invalidated permanently',
  'nav.refresh.detail3': 'All transaction data has been cleared',
  'nav.refresh.detail4': 'You cannot continue with this session',
  'nav.refresh.notice':
    'This protects your financial information from unauthorized access. Do not refresh/close the tab during secure transactions.',

  'nav.details.title': 'Security Violation Details',
  'nav.notice.title': 'Important Security Notice',
  'nav.actions.confirm': 'Close Session',
  'nav.actions.cancel': 'Stay on this page',
  'nav.footer': 'H&R Block – Security compliance notice',
};

export const disbursementsFr = {
  // Header
  'header.language': 'Langue:',
  // Refund Page
  'refund.step': 'Étape 1 sur 3',
  'refund.title': 'Votre remboursement est prêt!',
  'refund.step1.title': 'Assurons-nous qu’il s’agit bien de vous',
  'refund.step1.description':
    'Pour des raisons de sécurité, nous vous poserons quelques questions de vérification',
  'refund.step2.title': 'Sélectionnez où envoyer votre argent',
  'refund.step2.description':
    'Votre compte bancaire ou la nouvelle Carte Avantage Mastercard<sup><small>MD</small></sup> prépayée H&R Block',
  'refund.protip.title': '💡 Conseil Pro',
  'refund.protip.subtitle':
    'Rendez Votre Carte H&R Block Encore Plus Intelligente',
  'refund.protip.description':
    'Ajoutez votre carte à votre portefeuille numérique et profitez de paiements rapides et sécurisés partout où vous allez.',
  'refund.protip.apple': 'Apple Pay',
  'refund.protip.apple.desc': 'iPhone et Apple Watch',
  'refund.protip.google': 'Google Pay',
  'refund.protip.google.desc': 'Appareils Android',
  'refund.protip.samsung': 'Samsung Pay',
  'refund.protip.samsung.desc': 'Appareils Galaxy',
  'refund.protip.benefits.title': 'Paiements Rapides et Sécurisés',
  'refund.protip.benefits.desc':
    'Payez en tapant dans des millions d’endroits dans le monde avec une sécurité intégrée et une commodité sans effort.',
  'refund.button': 'Commencez',
  // Verification Page
  'verification.step': 'Étape 2 sur 3',
  'verification.back': 'Retour à l’Aperçu du Remboursement',
  'verification.title': 'Vérifiez votre identité.',
  'verification.subtitle':
    'Veuillez vérifier pour accéder à votre remboursement',
  'verification.subtitle.desc':
    'Pour accéder à votre remboursement, veuillez confirmer votre identité',
  'verification.personal.title': 'Renseignements personnels',
  'verification.firstName': 'Prénom *',
  'verification.firstName.placeholder': 'Entrez votre prénom',
  'verification.lastName': 'Nom de Famille *',
  'verification.lastName.placeholder': 'Entrez votre nom de famille',
  'verification.dob': 'Date de naissance*',
  'verification.dob.placeholder.date': 'JJ',
  'verification.dob.placeholder.month': 'MM',
  'verification.dob.placeholder.year': 'AAAA',
  'verification.sin':
    'Les quatre derniers chiffres du numéro d’assurance sociale*',
  'verification.sin.placeholder': '1234',
  'verification.sin.help':
    'Inscrivez les quatre derniers chiffres de votre NAS',
  'verification.captcha': 'Vérification de Sécurité (reCAPTCHA) *',
  'verification.captcha.text': 'Je ne suis pas un robot',
  'verification.captcha.help': 'Veuillez compléter la vérification reCAPTCHA.',
  'verification.agreements.title': 'Vérifier et accepter',
  'verification.agreement1':
    'J’accepte l’Accord du Porteur de Carte et comprends les termes et conditions de ma carte H&R Block.',
  'verification.agreement2':
    'J’autorise H&R Block à activer ma carte et à initier le transfert de fonds vers mon compte sélectionné.',
  'verification.agreement3':
    'J’accepte la Politique de Confidentialité et consens à la collecte et à l’utilisation de mes informations personnelles comme décrit.',
  'verification.security.title': 'Votre Confidentialité et Sécurité',
  'verification.security.desc':
    'Vos informations personnelles sont cryptées et transmises de manière sécurisée. H&R Block utilise des mesures de sécurité standard de l’industrie pour protéger vos données et ne partagera jamais vos informations sans votre consentement.',
  'verification.security.detailed':
    'Vos informations sont protégées par un cryptage de niveau bancaire et une transmission sécurisée. H&R Block suit les normes de pointe de l’industrie pour protéger vos données et ne partagera jamais vos détails personnels sans votre permission.',
  'verification.button': 'Continuer',
  'verification.button.help':
    'Veuillez remplir tous les champs requis pour continuer',
  'verification.error.failed': 'Nous n’avons pas pu vérifier vos coordonnées.',
  'verification.error.retry1':
    'Ce que vous avez saisi ne correspond pas à nos dossiers. Veuillez vérifier vos renseignements et réessayer. Vous pouvez <b>réessayer une fois de plus</b> avant que ce lien n’expire.',
  'verification.error.retry2':
    'Ce que vous avez inscrit ne correspond pas à nos dossiers. <br> Veuillez vérifier vos renseignements et réessayer. Vous avez <b>deux essais supplémentaires</b> avant que ce lien n’expire.',
  'verification.error.sin.invalid':
    'Entrez les 4 derniers chiffres de votre NAS.',
  'verification.error.dob.invalid':
    'Entrez une date de naissance dans un format valide.',
  // Transfer Options Page
  'transfer.step': 'Étape 3 sur 3',
  'transfer.back': 'Retour à la Vérification',
  'transfer.title': 'Choisissez Votre Méthode de Transfert',
  'transfer.subtitle':
    'Sélectionnez comment vous souhaitez recevoir votre remboursement',
  'transfer.balance.title': 'Votre remboursement d’impôt',
  'transfer.balance.available': 'Solde disponible',
  'transfer.section.title': 'Transférez votre remboursement.',
  'transfer.section.subtitle': 'Sélectionnez une des options suivantes.',
  'transfer.keep.title': 'Carte Avantage Mastercard<sup><small>MD</small></sup> prépayée H&amp;R Block',
  'transfer.keep.desc':
    'Activez et utilisez votre carte virtuelle Mastercard<sup><small>MD</small></sup>.\nAccès instantané à votre argent.\n<a href="https://www.hrblock.ca/fr/carteavantage">En savoir plus</a>',
  'transfer.keep.cardholder.link':
    '<a href="/cardholder-agreement.pdf">Les frais pour le titulaire de la carte</a>',
  'transfer.keep.cardholder': 's’appliquent.',
  'transfer.keep.fee':
    '<a href="https://hrblockadvantagecard.payaccount.io/cardholder-agreement">Les frais pour le titulaire de la carte</a> s’appliquent.',
  'transfer.visa.title': 'Visa* Direct',
  'transfer.visa.desc':
    'Transférez votre remboursement à votre <b>carte de débit Visa</b>.\nTransférez vos fonds à votre carte en quelques minutes.\n<a href="https://hrblockadvantagecard.mycardholdersupport.com/portal/fr-ca/kb/articles/visa-direct-demande-et-envoi">En savoir plus</a>',
  'transfer.interac.title': 'Virement Interac <sup><small>MD</small></sup>',
  'transfer.interac.desc':
    'Envoyez le remboursement à votre banque.\n Il faut prévoir jusqu à une heure pour que les fonds arrivent. \n<a href="https://hrblockadvantagecard.mycardholdersupport.com/portal/fr-ca/kb/articles/demande-et-envoi-par-virement-interac">En savoir plus</a>',
  'transfer.fee': 'Frais de virement:',
  'transfer.nofee': 'Aucun frais de virement',
  'transfer.button': 'Continuer avec',
  'transfer.continue': 'Continuer',
  'transfer.button.help.keep':
    'Vos fonds resteront disponibles sur votre carte H&R Block',
  'transfer.button.help.fee':
    'Frais de virement : seront déduits de votre solde',
  'transfer.dynamic.keep':
    'Vos fonds resteront disponibles sur votre carte H&R Block',
  'transfer.dynamic.fee': 'Frais de virement : seront déduits de votre solde',
  'transfer.select': 'Veuillez sélectionner une option pour continuer',
  // trademarks
  'transfer.trademark.disclaimer.interac':
    '<sup><small>MD</small></sup> Marque déposée d’Interac Corp. INTERAC et le logo INTERAC sont des marques de commerce d’Interac Corp. Utilisée sous licence.',
  'transfer.trademark.disclaimer.visa':
    '*Marque de commerce de Visa International Service Association. Utilisée sous licence par Peoples Trust Company.',
  'transfer.trademark.disclaimer.mastercard':
    'La Carte Mastercard<sup><small>MD</small></sup> prépayée Avantage H&R Block est émise par Peoples Trust Company conformément à une licence de Mastercard International.',

  // Create Account Page
  'account.step': 'Étape finale',
  'account.back': 'Retourner aux options',
  'account.title': 'Créer un nouveau compte.',
  'account.subtitle': 'Configurez votre',
  'account.subtitle.bold': 'Avantage Mastercard<sup><small>MD</small></sup> prépayée H&R Block',
  'account.info.title': 'Informations sur le compte',
  'account.username': 'Créer un nom d’utilisateur *',
  'account.username.placeholder':
    'Entrez un minimum de 3 caractères alphanumériques.',
  'account.username.valid': 'Le nom d’utilisateur est valide',
  'account.username.invalid':
    'Entrez un minimum de 3 caractères alphanumériques.',
  'account.password': 'Créer un mot de passe *',
  'account.password.placeholder': 'Choisir le mot de passe',
  'account.password.requirements': 'Exigences en matière de mot de passe :',
  'account.password.req1': '12 caractères ou plus',
  'account.password.req2': 'Contient une lettre majuscule',
  'account.password.req3': 'Contient une lettre minuscule',
  'account.password.req4': 'Contient un numéro',
  'account.password.req5': 'Contient un caractère spécial',
  'account.confirm': 'Confirmer le mot de passe *',
  'account.confirm.placeholder': 'Inscrivez de nouveau le mot de passe',
  'account.confirm.match': 'Les mots de passe correspondent',
  'account.confirm.nomatch': 'Les mots de passe ne correspondent pas',
  'account.security.title': 'Sécurité du compte',
  'account.security.desc':
    'Vos identifiants de compte sont chiffrés et stockés en toute sécurité. Vous les utiliserez pour accéder à votre compte de carte H&R Block et gérer vos fonds en ligne.',
  'account.button': 'Créer le compte',
  'account.button.help':
    'Veuillez inscrire les renseignements requis pour continuer.',
  'account.login': 'Compte Créé!',
  'account.login.message':
    'Votre compte de <b>Carte Avantage Mastercard prépayée H&R BlockMD</b> a été créé avec succès!',
  'account.username.error.title':
    'Le nom d’utilisateur existe déjà. Choisissez-en un autre.',
  'account.username.error.message':
    'Ce nom d’utilisateur est déjà utilisé. Veuillez créer un nom d’utilisateur avec un minimum de trois caractères. Vous pouvez ajouter des lettres et des chiffres pour le rendre unique.',
  // Account Created Page
  'accountCreated.title': 'Compte Déjà Créé',
  'accountCreated.message':
    'Ce lien de vérification a déjà été utilisé pour créer votre compte de carte',
  'accountCreated.message.bold': 'Avantage Mastercard<sup><small>MD</small></sup> prépayée H&R Block',
  'accountCreated.message._': '',
  'accountCreated.alreadyProcessed':
    'La configuration de votre compte a été complétée avec succès précédemment.',
  'accountCreated.info.title': 'Statut du Compte',
  'accountCreated.info.point1':
    'Votre compte de <b>Carte Avantage Mastercard prépayée H&R BlockMD</b> a été créé avec succès!',
  'accountCreated.info.point2':
    'Ce lien de vérification ne peut être utilisé qu’une seule fois pour des raisons de sécurité.',
  'accountCreated.info.point3':
    'Vous pouvez maintenant vous connecter pour accéder à votre compte et gérer votre carte.',
  'accountCreated.details.title': 'Ce Que Vous Pouvez Faire Maintenant',
  'accountCreated.access.title': 'Accédez à Votre Compte',
  'accountCreated.access.desc':
    'Connectez-vous avec votre nom d’utilisateur et mot de passe',
  'accountCreated.access.note':
    'Utilisez les identifiants que vous avez créés lors de la configuration du compte',
  'accountCreated.management.title': 'Gérez Votre Carte',
  'accountCreated.management.desc':
    'Consultez le solde, les transactions et les paramètres de la carte',
  'accountCreated.management.note':
    'Gestion complète du compte disponible en ligne',
  'accountCreated.nextSteps.title': 'Prochaines Étapes',
  'accountCreated.nextSteps.step1.label': 'Connectez-vous à votre compte',
  'accountCreated.nextSteps.step1.desc':
    'Utilisez votre nom d’utilisateur et mot de passe pour accéder à votre tableau de bord',
  'accountCreated.nextSteps.step2.label':
    'Consultez les détails de votre carte',
  'accountCreated.nextSteps.step2.desc':
    'Vérifiez votre solde et les transactions récentes',
  'accountCreated.nextSteps.step3.label': 'Commencez à utiliser votre carte',
  'accountCreated.nextSteps.step3.desc':
    'Effectuez des achats ou transférez des fonds selon vos besoins',
  'accountCreated.loginButton': 'Ouvrir une session',
  'accountCreated.startNewDemo': 'Commencer une Nouvelle Démo',
  // Visa Direct Page
  'visa.step': 'Étape 3 sur 3',
  'visa.back': 'Retour aux Options de Transfert',
  'visa.title': 'Transférer les fonds à une carte Visa.',
  'visa.subtitle': 'Inscrivez les',
  'visa.subtitle.visa': 'renseignements relatifs à votre carte de débit Visa',
  'visa.subtitle._': 'pour recevoir votre remboursement.',
  'visa.balance.title': 'Votre remboursement d’impôt',
  'visa.balance.available': 'Solde disponible',
  'visa.balance.fee': 'Frais de virement',
  'visa.card.title': 'Renseignements sur le destinataire.',
  'visa.firstName': 'Prénom *',
  'visa.middleName': 'Deuxième Prénom',
  'visa.lastName': 'Nom de Famille *',
  'visa.fullName': 'Nom Complet sur la Carte *',
  'visa.cardNumber': 'Numéro de la carte *',
  'visa.expiryMonth': 'Mois d’Expiration *',
  'visa.expiryYear': 'Année d’Expiration *',
  'visa.cvv': 'Code de sécurité (CVV - 3 chiffres)',
  'visa.button': 'Compléter le Transfert',
  'visa.button.help':
    'Veuillez inscrire les renseignements requis pour continuer.',
  'visa.submitTransfer': 'Continuer',
  // Transfer Success Page
  'success.title': 'Virement Visa envoyé.',
  'success.subtitle':
    'Vous avez transféré votre remboursement avec succès. Consultez le reçu ci-dessous pour connaître les détails du transfert.',
  'success.subtitle.completed':
    'La réception des fonds sur votre compte peut prendre quelques minutes.',
  'success.details.title': 'Détails de la transaction',
  'success.amount': 'Montant transféré',
  'success.fee': 'Frais de virement',
  'success.original': 'Montant initial',
  'success.id': 'ID de la transaction',
  'success.processor_reference': 'NRP',
  'success.method': 'Méthode de transfert',
  'success.method.interac': 'Virement Interac',
  'success.date': 'Date et heure',
  'success.complete.title': 'Transfert Terminé',
  'success.complete.desc':
    'Vos fonds ont été transférés avec succès vers votre carte de débit Visa et devraient être disponibles maintenant.',
  'success.download': 'Télécharger le Reçu',
  'success.share': 'Partager le Reçu',
  'success.next.title': 'Que Faire Ensuite?',
  'success.next.step1':
    'Vérifiez votre compte bancaire ou le solde de votre carte pour confirmer le transfert',
  'success.next.step2': 'Gardez votre ID de transaction pour vos dossiers',
  'success.next.step3':
    'Contactez le support si vous avez des questions sur votre transfert',
  'success.back': 'Commencer une Nouvelle Démo',
  // Account Home Page
  'home.demo.back': '← Retour au Début (Démo)',
  'home.welcome': 'Bienvenue sur votre Tableau de Bord, Ganesh Swami!',
  'home.cardNumber': 'Numéro de Carte XXXX XXXX XXXX 9251',
  'home.suspend': 'Suspendre la Carte',
  'home.nav.dashboard': 'Tableau de Bord',
  'home.nav.transfers': 'Transferts',
  'home.nav.profile': 'Mon Profil',
  'home.nav.card': 'À Propos de Ma Carte',
  'home.balance': 'Solde',
  'home.status': 'Statut du Compte',
  'home.status.active': 'Actif',
  'home.expiry': 'Date d’Expiration',
  'home.transactions': 'Transactions',
  'home.view': 'Voir',
  'home.export': 'Exporter vers:',
  'home.from': 'De:',
  'home.to': 'À:',
  'home.noTransactions': 'Aucune Transaction n’a été effectuée sur ce Compte',
  // Login Page
  'login.title': 'Connexion',
  'login.instruction':
    'Veuillez entrer votre nom d’utilisateur et mot de passe.',
  'login.activate': 'Si votre carte n’est pas activée,',
  'login.activate.link': 'cliquez ici pour l’activer',
  'login.register': 'Si votre carte est activée,',
  'login.register.link': 'cliquez ici pour enregistrer votre compte',
  'login.agreement':
    'Pour voir ou télécharger votre accord de porteur de carte,',
  'login.agreement.link': 'cliquez ici',
  'login.username': '* Nom d’utilisateur',
  'login.password': '* Mot de passe',
  'login.submit': 'Soumettre',
  'login.forgot': 'Mot de passe oublié',
  'login.back': '← Retour au Début (Démo)',
  'login.footer.mastercard':
    'Au Canada, la carte prépayée Mastercard est émise par Peoples Trust Company sous licence de Mastercard International Incorporated. Mastercard est une marque déposée, et le design du cercle est une marque de commerce de Mastercard International Incorporated.',
  'login.footer.visa.ca':
    'Au Canada, la carte prépayée Visa est émise par Equitable Bank conformément à une licence de Visa Int. *Marque de commerce de Visa Int, utilisée sous licence par Equitable Bank.',
  'login.footer.visa.us':
    'Aux États-Unis, la carte prépayée Visa® est émise par Sunrise Banks N.A., Membre FDIC, conformément à une licence de Visa U.S.A. Inc. Le logo Visa est une marque déposée de Visa International.',
  // Link Expired Page
  'expired.title': 'Votre lien a expiré',
  'expired.sorry': 'Votre lien de vérification a expiré en raison',
  'expired.sorry.bold': 'd’inactivité',
  'expired.timeout':
    'Les liens expirent après 48 heures d’inactivité pour votre sécurité.',
  'expired.what.title': 'Que s’est-il passé?',
  'expired.what.point1':
    'Votre lien de vérification Direct Send vous a été envoyé, mais il a maintenant expiré en raison de 48 heures d’inactivité.',
  'expired.what.point2':
    'Cette mesure de sécurité protège vos informations personnelles et les détails de votre remboursement.',
  'expired.what.point3':
    'Un nouveau lien de vérification doit être généré depuis le bureau H&R Block où vous avez produit vos impôts.',
  'expired.office.title': 'Visitez Votre Bureau H&R Block',
  'expired.office.instruction':
    'Votre lien de vérification a expiré en raison d’inactivité.',
  'expired.office.step1':
    'Visitez le même bureau H&R Block où vous avez produit vos impôts',
  'expired.office.step2':
    'Parlez avec un professionnel fiscal pour demander un nouveau lien de vérification Direct Send',
  'expired.office.step3':
    'Vous recevrez un nouveau lien par courriel ou SMS pour compléter votre processus de remboursement',
  'expired.bring.title': 'Que faire ensuite?',
  'expired.bring.id':
    'Rendez-vous au même bureau H&R Block où vous avez produit vos déclarations.',
  'expired.bring.sin':
    'Présentez une pièce d’identité avec photo valide émise par le gouvernement.',
  'expired.bring.receipt':
    'Parlez à un pro de l’impôt pour recevoir un nouveau lien.',
  'expired.start_new_demo': 'Commencer une Nouvelle Démo',
  // session terminated page
  'session.warning.title': 'Avertissement - Votre session sera annulée',
  'session.warning.instruction.back':
    'Si vous appuyez sur le bouton Précédente du navigateur, votre session sera interrompue et vous ne pourrez pas reprendre là où vous vous étiez arrêté(e). Vous devrez recommencer depuis le début.',
  'session.warning.instruction.refresh':
    'Si vous appuyez sur le bouton Actualiser du navigateur, votre session sera interrompue et vous ne pourrez pas reprendre là où vous vous étiez arrêté(e). Vous devrez recommencer depuis le début.',
  'session.warning.instruction.confirm':
    'IMPORTANT : Cette action mettra immédiatement fin à votre session en cours et toutes les données non enregistrées seront perdues. Vous devrez recommencer le processus depuis le début.',
  'session.terminated.title': 'Votre session a expiré',
  'session.terminated.instruction':
    'Votre session a été définitivement interrompue parce que le',
  'session.terminated.instruction.reason.back':
    'l’utilisation du bouton de retour du navigateur',
  'session.terminated.instruction.reason.refresh':
    'bouton Actualiser du navigateur',
  'session.terminated.reason': 'a été utilisée.',
  'session.terminated.nextstep':
    'Pour redémarrer, accédez au lien qui vous a été envoyé par courriel ou SMS.',
  'session.expired':
    'Votre session sécurisée a expiré. Vérifiez vos informations pour continuer.',
  // Interac Transfer Page
  'interac.step': 'Étape 3 sur 3',
  'interac.back': 'Retour aux Options de Transfert',
  'interac.balance.title': 'Votre remboursement d’impôt',
  'interac.balance.available': 'Solde disponible',
  'interac.balance.fee': 'Frais de virement',
  'interac.title': 'Virement Interac.<sup><small>MD</small></sup>',
  'interac.subtitle':
    'Entrez votre courriel de virement Interac pour recevoir les fonds',
  'interac.contact.title': 'Renseignements sur le destinataire',
  'interac.name': 'Nom *',
  'interac.email': 'Courriel *',
  'interac.security.question': 'Question de sécurité',
  'interac.security.answer': 'Réponse de sécurité',
  'interac.security.answer.placeholder': 'Inscrivez la réponse de sécurité.',
  'interac.checking': 'Vérification du statut de dépôt automatique...',
  'interac.auto.enabled': '✅ Dépôt Automatique Activé',
  'interac.auto.enabled.desc':
    'Parfait! Le dépôt automatique est activé pour ce courriel. Aucune question de sécurité requise.',
  'interac.auto.checking': '🔍 Vérification du Statut de Dépôt Automatique',
  'interac.auto.checking.desc':
    'Vérification si le dépôt automatique est activé pour cette adresse courriel...',
  'interac.info.title': '💡 Informations sur le Virement Interac',
  'interac.info.time':
    '• Temps de transfert: Se complète généralement en quelques minutes à quelques heures',
  'interac.info.transferTime': 'Temps de transfert:',
  'interac.info.transferTimeValue':
    'Se complète généralement en quelques minutes à quelques heures',
  'interac.info.security': 'Sécurité:',
  'interac.info.security.required':
    'Question de sécurité requise pour ce transfert',
  'interac.info.security.auto':
    'Dépôt automatique activé - aucune question de sécurité nécessaire',
  'interac.info.security.pending':
    'Les exigences de sécurité seront déterminées après la vérification du courriel',
  'interac.info.fee':
    '• Frais: Des frais de transfert de 3,95 $ seront déduits de votre solde',
  'interac.info.feeLabel': 'Frais:',
  'interac.info.feeValue':
    'Des frais de transfert de 3,95 $ seront déduits de votre solde',
  'interac.submit': 'Continuer',
  'interac.submit.checking': 'Vérification...',
  'interac.submit.help.checking':
    'Veuillez patienter pendant que nous vérifions le statut de dépôt automatique',
  'interac.submit.help.demo':
    'Veuillez sélectionner une option de dépôt automatique pour la démo PTC',
  'interac.submit.help.complete':
    'Veuillez remplir tous les champs requis pour continuer.',
  'interac.demo.ptc': '🔧 Options de Démo PTC',
  'interac.demo.ptc.desc':
    'Choisissez le statut de dépôt automatique pour les tests (Démo Seulement)',
  'interac.demo.enabled': '✅ Dépôt Automatique Activé',
  'interac.demo.disabled': '⚠️ Dépôt Automatique Non Activé',
  'interac.demo.exceptions': '🧪 Scénarios d’Exception de Démo',
  'interac.demo.exceptions.desc':
    'Testez différents scénarios d’erreur de transfert (Démo Seulement)',
  'interac.demo.escrow': '⏰ Erreur de Solde d’Entiercement Insuffisant',
  'interac.demo.network': '📡 Erreur de Réseau de Virement Électronique',
  'interac.transfer.failed': 'Échec du transfert - Problème technique',
  'interac.transfer.failed.message':
    'Votre virement Interac a échoué en raison d’une erreur technique. Si le problème persiste, veuillez communiquer avec le service d’assistance aux titulaires de cartes au 1 855 342-6924 ou à l’adresse hrblockadvantagecard@mycardholdersupport.com.',
  'interac.transfer.unavailable': 'Transfert temporairement indisponible',
  'interac.transfer.unavailable.message':
    'Nous rencontrons des problèmes temporaires. Veuillez réessayer dans 24 heures',

  // Shared escrow error messages (used by both Visa and Interac)
  'disbursement.error.insufficient_escrow.title': 'Transfert Temporairement Indisponible',
  'disbursement.error.insufficient_escrow.message':
    'Nous rencontrons un problème temporaire avec notre processeur de paiement qui empêche les transferts en ce moment. Veuillez réessayer votre transfert dans 4 heures. Nous nous excusons pour tout inconvénient.',

  // Add these missing keys to the FR translations:
  'interac.stepIndicator': 'Étape 3 sur 3',
  'interac.backButton': 'Retour aux Options de Transfert',
  'interac.yourHRBlockCard': 'Votre Carte H&R Block',
  'interac.availableBalance': 'Solde disponible',
  'interac.transferFee': 'Frais de virement: 3,95 $',
  'interac.namePlaceholder': 'Entrez le nom complet du destinataire',
  'interac.emailPlaceholder': 'Entrez l’adresse courriel du virement Interac',
  'interac.checkingAutoDeposit':
    'Vérification du statut de dépôt automatique...',
  'interac.autoDeposit.enabled.title': '✅ Dépôt Automatique Activé',
  'interac.autoDeposit.enabled.subtitle':
    'Parfait! Le dépôt automatique est activé pour ce courriel. Aucune question de sécurité requise.',
  'interac.autoDeposit.checking.title':
    '🔍 Vérification du Statut de Dépôt Automatique',
  'interac.autoDeposit.checking.subtitle':
    'Vérification si le dépôt automatique est activé pour cette adresse courriel...',
  'interac.info.securityRequirements':
    'Les exigences de sécurité seront déterminées après la vérification du courriel',
  'interac.info.securityQuestionRequired':
    'Question de sécurité requise pour ce transfert',
  'interac.info.autoDepositEnabled':
    'Dépôt automatique activé - aucune question de sécurité nécessaire',
  'interac.submitTransfer': 'Continuer',
  'interac.waitAutoDeposit':
    'Veuillez patienter pendant que nous vérifions le statut de dépôt automatique',
  'interac.selectAutoDepositOption':
    'Veuillez sélectionner une option de dépôt automatique pour la démo PTC',
  'interac.completeRequiredFields':
    'Veuillez remplir tous les champs requis pour continuer.',
  'interac.ptcDemoOptions.title': '🔧 Options de Démo PTC',
  'interac.ptcDemoOptions.subtitle':
    'Choisissez le statut de dépôt automatique pour les tests (Démo Seulement)',
  'interac.ptcDemoOptions.enabled': '✅ Dépôt Automatique Activé',
  'interac.ptcDemoOptions.disabled': '⚠️ Dépôt Automatique Non Activé',
  'interac.demoException.title': '🧪 Scénarios d’Exception de Démo',
  'interac.demoException.subtitle':
    'Testez différents scénarios d’erreur de transfert (Démo Seulement)',
  'interac.demoException.escrow':
    '⏰ Erreur de Solde d’Entiercement Insuffisant',
  'interac.demoException.network':
    '📡 Erreur de Réseau de Virement Électronique',
  'interac.dismiss': 'Ignorer',
  'interac.demoOnly': 'Démo Seulement',
  'interac.error.name': 'Entrez votre nom pour continuer.',
  'interac.error.name.length': 'Le nom doit avoir au moins 2 caractères',
  'interac.error.name.consecutiveSpaces': 'Le nom ne peut pas contenir des espaces consécutifs',
  'interac.error.email': 'Entrez votre courriel pour continuer.',
  'interac.error.email.invalid': 'Entrez une adresse courriel valide, par exemple nom@exemple.com.',
  'interac.error.email.rejected':
    'Nous n’avons pas pu utiliser cette adresse courriel. Vérifiez-la, puis réessayez.',
  'interac.error.name.characters':
    'Votre nom ne peut contenir que des lettres, des chiffres, des espaces et des traits d’union, et doit compter de 3 à 80 caractères.',
  'interac.error.name.firstLast':
    'Entrez seulement votre prénom et votre nom de famille, séparés par une espace (par exemple, Marie Tremblay).',
  'interac.error.name.rejected':
    'Nous n’avons pas pu utiliser ce nom. Vérifiez-le, entrez votre prénom et votre nom de famille, puis réessayez.',
  'interac.error.details.title': 'Vérifiez votre nom et votre courriel',
  'interac.error.details.message':
    'Nous n’avons pas pu configurer le virement avec le nom et l’adresse courriel saisis. Vérifiez que le nom correspond à votre prénom et à votre nom de famille et que l’adresse courriel est exacte, puis réessayez.',
  'interac.emailConfirm': 'Confirmer le courriel *',
  'interac.emailConfirm.placeholder': 'Inscrivez de nouveau le courriel de virement Interac.',
  'interac.error.emailConfirm': 'Inscrivez de nouveau votre courriel pour le confirmer.',
  'interac.error.emailConfirm.mismatch':
    'Les adresses courriel ne correspondent pas. Vérifiez-les pour repérer les fautes de frappe.',
  'interac.error.securityAnswer':
    'Entrez une réponse à la question de sécurité.',
  'interac.error.securityAnswer.minLength':
    'La réponse de sécurité doit contenir de 3 à 25 caractères, uniquement des lettres et des chiffres (sans espaces).',
  'interac.error.securityAnswer.maxLength':
    'La réponse de sécurité doit contenir de 3 à 25 caractères, uniquement des lettres et des chiffres (sans espaces).',
  'interac.error.securityAnswer.pattern':
    'La réponse de sécurité doit contenir de 3 à 25 caractères, uniquement des lettres et des chiffres (sans espaces).',
  // Add these missing placeholder keys for interac transfer page
  'interac.name.placeholder': 'Inscrivez le nom complet.',
  'interac.email.placeholder': 'Inscrivez le courriel de virement Interac.',
  'interac.autodeposit.enabled':
    'Dépôt automatique activé - aucune question de sécurité requise',
  'interac.autodeposit.disabled':
    'Le dépôt automatique n’est pas activé. Entrez une question de sécurité.',
  // Interac Success Page
  'interac.success.title': 'Virement Interac<sup><small>MD</small></sup> envoyé.',
  'interac.success.subtitle':
    'Un courriel d’Interac sera envoyé dans l’heure qui suit. Veuillez suivre les instructions pour effectuer la transaction.',
  'interac.success.subtitle.autodeposit':
    'Permettez jusqu’à 1 heure pour que les fonds arrivent',
  'interac.success.details': 'Détails de la transaction',
  'interac.success.amount': 'Montant Transféré',
  'interac.success.fee': 'Frais de Transfert',
  'interac.success.original': 'Montant Initial',
  'interac.success.recipient.name': 'Nom du Destinataire',
  'interac.success.recipient.email': 'Courriel du Destinataire',
  'interac.success.id': 'ID de la transaction',
  'interac.success.method': 'Méthode de Transfert',
  'interac.success.method.interac': 'Virement Interac',
  'interac.success.date': 'Date et Heure',
  'interac.success.status.title': '✅ Transfert Initié avec Succès',
  'interac.success.status.desc': 'Votre virement Interac a été envoyé à',
  'interac.success.status.instruction':
    'Le destinataire recevra une notification par courriel avec les instructions pour déposer les fonds.',
  'interac.success.delivery':
    '• Livraison prévue: En quelques minutes à quelques heures',
  'interac.success.notification':
    '• Notification du destinataire: Courriel envoyé automatiquement',
  'interac.success.security.question':
    'Question de sécurité requise pour le dépôt',
  'interac.success.security.auto':
    'Dépôt automatique activé - aucune question de sécurité nécessaire',
  'interac.success.next.title': 'Que se passe-t-il ensuite?',
  'interac.success.next.step1':
    '1. Notification par courriel envoyée: Le destinataire recevra un courriel d’Interac avec les instructions de dépôt',
  'interac.success.next.step2':
    '2. Le destinataire dépose les fonds: Il suivra le lien dans le courriel pour déposer l’argent dans son compte bancaire',
  'interac.success.next.step3':
    '3. Le transfert se complète: Une fois déposé, le transfert est terminé et les fonds sont disponibles pour le destinataire',
  'interac.success.next.step4':
    '4. Gardez votre ID de transaction: Sauvegardez ceci pour vos dossiers au cas où vous devriez référencer ce transfert',
  'interac.success.download': 'Télécharger le reçu',
  'interac.success.share': 'Partager le reçu',
  'interac.success.amountTransferred': 'Montant transféré',
  'interac.success.transferFee': 'Frais de virement',
  'interac.success.originalAmount': 'Montant initial',
  'interac.success.recipientName': 'Nom du Destinataire',
  'interac.success.recipientEmail': 'Envoyé à',
  'interac.success.transactionId': 'ID de la transaction',
  'interac.success.reference': 'NRP',
  'interac.success.transferMethod': 'Méthode de transfert',
  'interac.success.dateTime': 'Date et heure',
  'interac.success.transferInitiated': 'Transfert Initié avec Succès',
  'interac.success.transferSent': 'Votre virement Interac a été envoyé à',
  'interac.success.recipientNotification':
    'Le destinataire recevra une notification par courriel avec les instructions pour déposer les fonds.',
  'interac.success.expectedDeliveryLabel': 'Livraison prévue',
  'interac.success.expectedDelivery': 'En quelques minutes à quelques heures',
  'interac.success.recipientNotificationLabel': 'Notification du destinataire',
  'interac.success.emailSentAutomatically': 'Courriel envoyé automatiquement',
  'interac.success.securityLabel': 'Sécurité',
  'interac.success.securityQuestionRequired':
    'Question de sécurité requise pour le dépôt',
  'interac.success.autoDepositEnabled':
    'Dépôt automatique activé - aucune question de sécurité nécessaire',
  'interac.success.whatHappensNextTitle': 'Que se passe-t-il ensuite?',
  'interac.success.nextStep1Label': 'Notification par courriel envoyée',
  'interac.success.nextStep1':
    'Le destinataire recevra un courriel d’Interac avec les instructions de dépôt',
  'interac.success.nextStep2Label': 'Le destinataire dépose les fonds',
  'interac.success.nextStep2':
    'Il suivra le lien dans le courriel pour déposer l’argent dans son compte bancaire',
  'interac.success.nextStep3Label': 'Le transfert se complète',
  'interac.success.nextStep3':
    'Une fois déposé, le transfert est terminé et les fonds sont disponibles pour le destinataire',
  'interac.success.nextStep4Label': 'Gardez votre ID de transaction',
  'interac.success.nextStep4':
    'Sauvegardez ceci pour vos dossiers au cas où vous devriez référencer ce transfert',
  'success.alert.title': 'Remboursement envoyé',
  'success.alert.message':
    'Votre remboursement a été transféré avec succès. Consultez le reçu ci-dessous pour connaître les détails du transfert.',
  'success.alert.date': ' à la date indiquée ci-dessous.',
  'success.status.title': 'Transfert Terminé',
  'success.status.message':
    'Vos fonds ont été transférés avec succès et devraient être disponibles maintenant.',
  'interac.success.expectedDeliveryTime':
    'Temps de livraison prévu: En quelques minutes à quelques heures selon la banque du destinataire',
  'interac.success.auto.title': 'Virement Interac envoyé.',
  'interac.success.auto.subtitle':
    'Il faut prévoir jusqu’à une heure pour que les fonds arrivent.',
  'interac.success.auto.depositTitle': 'Dépôt Automatique Terminé',
  'interac.success.auto.depositMessage':
    'Votre virement Interac a été automatiquement déposé dans le compte bancaire du destinataire. Aucune action supplémentaire n’est requise de la part du destinataire.',
  'interac.success.auto.availabilityMessage':
    'Les fonds sont maintenant disponibles dans le compte du destinataire et peuvent être utilisés immédiatement.',
  // Visa Direct Page - Error messages
  'visa.error.verification.title': 'Échec de la vérification de la carte',
  'visa.error.verification.message':
    'Votre carte n’a pas pu être vérifiée. Veuillez vérifier les <b>renseignements relatifs à votre carte</b> et réessayer.',
  'visa.error.fraud.title': 'Carte non admissible à la transaction',
  'visa.error.fraud.message':
    'Cette carte n’est pas admissible au transfert Visa Direct. Veuillez réessayer avec une autre carte de débit Visa.',
  'visa.error.escrow.title': 'Transfert Temporairement Indisponible',
  'visa.error.escrow.message':
    'Nous rencontrons un problème temporaire avec notre processeur de paiement qui empêche les transferts en ce moment. Veuillez réessayer votre transfert demain ou après 24 heures. Nous nous excusons pour tout inconvénient.',
  'visa.demo.title': '🧪 Scénarios d’Exception de Démo',
  'visa.demo.subtitle':
    'Testez différents scénarios d’erreur de transfert (Démo Seulement)',
  'visa.demo.verification': '⚠️ Échec de la vérification de la carte',
  'visa.demo.fraud': '🛡️ Fraude Suspectée',
  'visa.demo.escrow': '⏰ Erreur de Solde d’Entiercement Insuffisant',
  'visa.error.dismiss': 'Ignorer',
  // visa.errors.* keys (used in errorMap)
  'visa.errors.verification.title': 'Échec de la vérification de la carte',
  'visa.errors.verification.message':
    'Votre carte n’a pas pu être vérifiée. Veuillez vérifier les <b>renseignements relatifs à votre carte</b> et réessayer.',
  'visa.errors.fraud.title': 'Carte non admissible à la transaction',
  'visa.errors.fraud.message':
    'Cette carte n’est pas admissible au transfert Visa Direct. Veuillez réessayer avec une autre carte de débit Visa.',
  'visa.errors.escrow.title': 'Transfert Temporairement Indisponible',
  'visa.errors.escrow.message':
    'Nous rencontrons un problème temporaire avec notre processeur de paiement qui empêche les transferts en ce moment. Veuillez réessayer votre transfert demain ou après 24 heures. Nous nous excusons pour tout inconvénient.',
  'visa.errors.dismiss': 'Ignorer',
  // Transfer Success Page - Additional
  'success.status.complete': '✅ Transfert Terminé',
  'success.status.desc':
    'Vos fonds ont été transférés avec succès vers votre carte de débit Visa et devraient être disponibles maintenant.',
  'success.completed.title': 'Transfert Déjà Terminé',
  'success.completed.desc':
    'Ce lien de vérification a déjà été utilisé. Votre transfert a été traité avec succès à la date indiquée ci-dessous.',
  // Demo sections (common across pages)
  'demo.title': '🧪 Scénarios d’Exception de Démo',
  'demo.desc':
    'Testez différents scénarios de gestion d’exception (Démo Seulement)',
  'demo.verification.scenarios': '🧪 Scénarios d’Échec de Vérification de Démo',
  'demo.verification.desc':
    'Testez des scénarios d’échec de vérification progressifs (Démo Seulement)',
  'demo.fail1': '⚠️ 1er Échec de Vérification',
  'demo.fail2': '🚨 2e Échec de Vérification',
  'demo.fail3': '🔒 3e Échec de Vérification',
  'demo.money.complete': '💰 Transfert d’Argent Terminé',
  'demo.account.created': '✅ Compte Créé',
  'demo.link.expired': '⚠️ Lien Expiré',
  // Common form elements
  'form.required': '*',
  'form.dismiss': 'Ignorer',
  'form.back': 'Retour',
  'form.continue': 'Continuer',
  'form.submit': 'Soumettre',
  'form.complete': 'Terminer',
  'form.checking': 'Vérification...',
  'form.processing': 'Traitement...',
  // Common
  'common.cardholder': 'Accord du Porteur de Carte',
  'common.privacy': 'Politique de Confidentialité',
  'common.goBack': 'Retourner aux options',
  'common.goBackVerify': 'Retourner',
  'common.dismiss': 'Ignorer',
  'verification.dob.placeholder': 'MM/JJ/AA',
  'transfer.interac.setup':
    'Nécessite une configuration d’email et de question de sécurité.',
  'transfer.interac.learnmore': 'En savoir plus',
  'account.username.help':
    'Votre nom d’utilisateur sera utilisé pour vous connecter à votre compte.',
  'account.username.description':
    'Votre nom d’utilisateur sera utilisé pour vous connecter à votre compte.',
  'visa.nameOnCard': 'Nom sur la carte *',
  'visa.nameOnCard.placeholder': 'Inscrivez le nom complet.',
  'visa.nameOnCard.help':
    'Inscrivez le nom figurant sur la carte de débit Visa.',
  'visa.expiry': 'Date d’expiration',
  'visa.noCvvNeeded': 'Aucun CVV requis.',
  'visa.address1': 'Adresse - ligne 1 *',
  'visa.address1.help':
    'Inscrivez l’adresse associée à la carte de débit Visa.',
  'visa.address2': 'Adresse - ligne 2',
  'visa.city': 'Ville *',
  'visa.provinceState': 'Province *',
  'visa.provinceState.placeholder': 'Sélectionnez la province.',
  'visa.postalCode': 'Code postal *',
  'visa.country': 'Pays',
  'visa.continue': 'Continuer',
  'success.prn': 'NRP',
  'interac.auto.disabled':
    'Dépôt automatique non activé - question de sécurité requise',
  'interac.success.prn': 'NRP',
  'validation.name.required': 'Entrez votre nom pour continuer.',
  'validation.name.minLength': 'Le nom doit contenir au moins 2 caractères',
  'validation.email.required': 'Le courriel est requis',
  'validation.email.invalid': 'Veuillez entrer une adresse courriel valide',
  'validation.securityQuestion.required': 'La question de sécurité est requise',
  'validation.securityAnswer.required': 'La réponse de sécurité est requise',
  'validation.securityAnswer.minLength':
    'La réponse de sécurité doit contenir au moins 2 caractères',
  'visa.errors.fullNameOnCard.required':
    'Le nom sur la carte est requis. Entrez le nom exact figurant sur votre carte Visa.',
  'visa.errors.fullNameOnCard.minLength':
    'Le nom doit contenir au moins 2 caractères',
  'visa.errors.cardNumber.required': 'Le numéro de carte est requis.',
  'visa.errors.cardNumber.exactLength':
    'Le numéro de carte doit contenir exactement 16 chiffres',
  'visa.errors.cardNumber.onlyDigits':
    'Le numéro de carte ne doit contenir que des chiffres',
  'visa.errors.cardNumber.invalid': 'Veuillez entrer un numéro de carte valide',
  'visa.errors.cvv.required': 'Le CVV est requis. Entrez le code à 3 chiffres.',
  'visa.errors.cvv.exactLength':
    'Le code de sécurité doit contenir exactement 3 chiffres',
  'visa.errors.expiryMonth.required': 'La ligne 1 de l’adresse est requise.',
  'visa.errors.expiryMonth.invalid': 'Veuillez sélectionner un mois valide',
  'visa.errors.expiryYear.required': 'L’année d’expiration est requise',
  'visa.errors.expiryYear.expired': 'La carte a expiré',
  'visa.errors.expiryYear.invalid': 'Veuillez sélectionner une année valide',
  'visa.errors.address1.required': 'L’adresse ligne 1 est requise',
  'visa.errors.address1.minLength':
    'L’adresse doit contenir au moins 5 caractères',
  'visa.errors.city.required': 'La ville est requise.',
  'visa.errors.city.minLength': 'La ville doit contenir au moins 2 caractères',
  'visa.errors.provinceState.required': 'La province est requise.',
  'visa.errors.postalCode.required': 'Le code postal est requis.',
  'visa.errors.postalCode.invalidFormat':
    'Entrez un code postal valide (A1A 1A1).',
  'visa.errors.country.required': 'Le pays est requis',
  'visa.errors.country.onlyCanada':
    'Seules les adresses canadiennes sont supportées',
  'valid_etransfer_name':
    'Entrez le prénom et le nom de famille du destinataire',
  // verification failed french
  'verificationFailed.title': 'Échec de la vérification',
  'verificationFailed.terminated': 'Ce lien a expiré en raison de',
  'verificationFailed.terminated.bold':
    'l’échec de plusieurs tentatives de vérification.',
  'verificationFailed.nextSteps.title': 'Que faire ensuite?',
  'verificationFailed.nextSteps.step1': 'Visitez le',
  'verificationFailed.nextSteps.step1.1': 'même bureau H&R Block',
  'verificationFailed.nextSteps.step1.2':
    'où vous avez produit vos déclarations.',
  'verificationFailed.nextSteps.step2':
    'Présentez une pièce d’identité avec photo valide émise par le gouvernement.',
  'verificationFailed.nextSteps.step3':
    'Parlez à un pro de l’impôt pour recevoir un nouveau lien.',
  'verificationFailed.nextSteps.step4':
    'Demandez un nouveau lien de vérification afin d’accéder à votre remboursement.',
  // Navigation guard modal (FR)
  'nav.back.title': 'Violation de navigation détectée',
  'nav.back.lead': 'Navigation non autorisée détectée. Session terminée.',
  'nav.back.desc':
    'Vous avez tenté d’utiliser le bouton Précédent du navigateur durant une transaction financière sécurisée. Cette action enfreint nos protocoles de sécurité et votre session a été définitivement terminée pour protéger vos renseignements.',
  'nav.back.detail1': 'Utilisation du bouton Précédent du navigateur détectée',
  'nav.back.detail2':
    'La session sécurisée a été invalidée de façon permanente',
  'nav.back.detail3': 'Toutes les données de transaction ont été supprimées',
  'nav.back.detail4':
    'La session ne peut pas être rétablie pour des raisons de sécurité',
  'nav.back.notice':
    'Cette mesure de sécurité protège vos renseignements financiers contre tout accès non autorisé. L’utilisation des fonctions de navigation du navigateur est strictement interdite durant les transactions sécurisées. Cette session est maintenant définitivement fermée.',
  'nav.refresh.title': 'Session terminée',
  'nav.refresh.lead': 'Votre session a été définitivement terminée car le',
  'nav.refresh.lead.bold': 'bouton d’actualisation du navigateur',
  'nav.refresh.lead._': 'a été utilisé.',
  'nav.refresh.restart':
    'Pour recommencer, accédez au lien qui vous a été envoyé par courriel et/ou SMS.',
  'nav.refresh.desc':
    'Nous avons détecté que vous avez tenté d’actualiser ou de fermer le navigateur durant le processus de transfert. Pour votre sécurité, cette action n’est pas autorisée et votre session a été terminée.',
  'nav.refresh.detail1':
    'Tentative d’actualisation/fermeture du navigateur détectée',
  'nav.refresh.detail2':
    'La session sécurisée a été invalidée de façon permanente',
  'nav.refresh.detail3': 'Toutes les données de transaction ont été effacées',
  'nav.refresh.detail4': 'Vous ne pouvez pas continuer avec cette session',
  'nav.refresh.notice':
    'Cela protège vos renseignements financiers contre tout accès non autorisé. N’actualisez pas et ne fermez pas l’onglet durant les transactions sécurisées.',
  'nav.details.title': 'Détails de l’infraction à la sécurité',
  'nav.notice.title': 'Avis de sécurité important',
  'nav.actions.confirm': 'Fermer la session',
  'nav.actions.cancel': 'Rester sur cette page',
  'nav.footer': 'H&R Block – Avis de conformité à la sécurité',
};
